import * as React from 'react'
import { IconSVGType } from '../../../types/icons'

export const CardIcon = (props: IconSVGType) => (
  <svg
    width='20'
    height='16'
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id="credit-card-icon">Credit Card</title>
    <path
      d='M18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM17 14H3C2.45 14 2 13.55 2 13V8H18V13C18 13.55 17.55 14 17 14ZM18 4H2V2H18V4Z'
      fill='black'
    />
  </svg>
)
